<template>
  <content-block class="password-change" required>
    <div slot="instructions">
      <h5>{{ $t("Password Change") }}</h5>
      <p>{{ $t("A minimum of 6 characters is needed for passwords") }}</p>
    </div>

    <div slot="content">
      <div class="form">
        <UIInput
          type="password"
          class="currentpassword"
          :title="$t('Current Password')"
          v-model="currentPassword"
          :error="!currentPasswordValid"
          :error-msg="$t('Too few characters')"
        />
        <UIInput
          type="password"
          class="newpassword"
          :title="$t('New Password')"
          v-model="password"
          :error="!passwordValid"
          :error-msg="$t('Too few characters')"
        />
        <UIInput
          type="password"
          class="confirmationpassword"
          :title="$t('Confirm New Password')"
          v-model="passwordConfirmation"
          :error="!passwordConfirmationValid"
          :error-msg="$t('Passwords do not match')"
        />
        <UIButton
          class="submitbtn"
          v-if="!success"
          :disabled="!buttonEnabled"
          @click="changePassword"
        >{{ $t('Change Password') }}</UIButton>
        <div class="success" v-if="success">
          <svg>
            <use xlink:href="#icon-check"></use>
          </svg>
          {{ $t('Successfully Changed Password') }}
        </div>
      </div>
    </div>
  </content-block>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import ContentBlock from '../components/ContentBlock';
import UIInput from '../components/ui/UIInput';
import UIButton from '../components/ui/UIButton';

/**
 * Okay I know we could use vee validate, or some other validation library. But we've needed it so
 * infrequently, that it just made more sense to code it kind of from scratch, even if it is a lot
 * of boilerplate.
 *
 * If we end up making a validate library part of our core deps, change this.
 */

@Component({
  components: {
    ContentBlock,
    UIInput,
    UIButton,
  },
})
export default class PasswordChange extends Vue {
  currentPassword = '';
  password = '';
  passwordConfirmation = '';
  success = false;

  get currentPasswordValid () {
    return (this.currentPassword.length === 0) ? true : this.currentPassword.length > 6;
  }

  get passwordValid () {
    return this.password.length === 0 || this.password.length > 6;
  }

  get passwordConfirmationValid () {
    return this.passwordConfirmation.length === 0 || this.password === this.passwordConfirmation;
  }

  get buttonEnabled () {
    return this.currentPassword.length > 6 && this.password.length > 6 && this.passwordConfirmation.length > 6 && this.currentPasswordValid && this.passwordValid && this.passwordConfirmationValid;
  }

  changePassword () {
    this.$store.dispatch('changePassword', {
      currentPassword: this.currentPassword,
      password: this.password,
      passwordConfirmation: this.passwordConfirmation,
    }).then(() => {
      this.success = true;
    });
  }
}
</script>

<style scoped lang="postcss">
@import "../styles";

.password-change {
  & .form {
    display: grid;
    grid-gap: var(--spacingSm);
    align-items: end;
    @media (--tablet) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (--desktop) {
      column-gap: var(--spacingMd);
    }
  }

  & .success {
    display: flex;
    color: var(--colorSuccess);
    fill: var(--colorSuccess);
    align-items: center;
    @apply --f6;
    margin: 0;

    & svg {
      width: 2.5rem;
      height: 2.5rem;
      margin-right: var(--spacingSm);
    }
  }
}
</style>
